<template>
  <div id="main-content" class="detail-parent">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form v-if="parentInfo">
        <el-row class="row-section">
          <h3>{{ $t('common.basic_information') }}</h3>
        </el-row>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span"> {{ parentInfo.name }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.gender') }}:</span>
            <span class="info-span" v-if="parentInfo.gender">{{ $t('common.male') }}</span>
            <span class="info-span" v-else>{{ $t('common.female') }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.furigana') }}:</span>
            <span class="info-span"> {{ parentInfo.furigana }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.romaji') }}:</span>
            <span class="info-span"> {{ parentInfo.romaji }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.email') }}:</span>
            <span class="info-span"> {{ parentInfo.email }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline;">
            <span class="form-lable">{{ $t('common.phone') }}:</span>
            <span class="info-span"> {{ parentInfo.phone }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.address_1') }}:</span>
            <span class="info-span"> {{ parentInfo.address_1 }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline;">
            <span class="form-lable">{{ $t('common.address_2') }}:</span>
            <span class="info-span"> {{ parentInfo.address_2 }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.member') }}:</span>
            <span class="info-span" v-if="parentInfo.is_member">{{ $t('common.yes') }}</span>
            <span class="info-span" v-else>{{ $t('common.no') }}</span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable" style="width: 20%">{{ $t('common.active') }}</span>
            <span class="info-span">{{ parentInfo.is_active ? $t('common.yes') : $t('common.no') }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable" style="width: 20%">{{ $t('common.image') }}</span>
            <img class="info-span" v-bind:src="parentInfo.image" width="30%"/>
          </el-col>
        </el-row>

        <el-row class="row-section mb-2">
          <span style="font-size: 22px">{{ $t('add_parent.files') }}</span>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(file, indexF) in parentInfo.attach_files" :key="indexF">
            <img class="info-span info-span__file" @click="onShowPreviewPDF(file)" :src="getImageByType(file)" />
          </el-col>
        </el-row>

        <div v-if="parentInfo.partner_info.name !== ''">
          <el-row class="row-section">
            <h3>{{ $t('common.partner_information') }}</h3>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="11" style="display: inline">
              <span class="form-lable">{{ $t('common.full_name') }}:</span>
              <span class="info-span"> {{ parentInfo.partner_info.name }} </span>
            </el-col>
            <el-col :offset="1" :span="12" style="display: inline">
              <span class="form-lable">{{ $t('common.gender') }}:</span>
              <span class="info-span" v-if="parentInfo.partner_info.gender">{{ $t('common.male') }}</span>
              <span class="info-span" v-else>{{ $t('common.female') }}</span>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="11" style="display: inline">
              <span class="form-lable">{{ $t('common.furigana') }}:</span>
              <span class="info-span"> {{ parentInfo.partner_info.furigana }} </span>
            </el-col>
            <el-col :offset="1" :span="12" style="display: inline">
              <span class="form-lable">{{ $t('common.romaji') }}:</span>
              <span class="info-span"> {{ parentInfo.partner_info.romaji }} </span>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="11" style="display: inline">
              <span class="form-lable">{{ $t('common.email') }}:</span>
              <span class="info-span"> {{ parentInfo.partner_info.email }} </span>
            </el-col>
            <el-col :offset="1" :span="12" style="display: inline">
              <span class="form-lable">{{ $t('common.phone') }}:</span>
              <span class="info-span"> {{ parentInfo.partner_info.phone }} </span>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="11" style="display: inline">
              <span class="form-lable">{{ $t('common.address_1') }}:</span>
              <span class="info-span"> {{ parentInfo.partner_info.address_1 }} </span>
            </el-col>
            <el-col :offset="1" :span="12" style="display: inline">
              <span class="form-lable">{{ $t('common.address_2') }}:</span>
              <span class="info-span"> {{ parentInfo.partner_info.address_2 }} </span>
            </el-col>
          </el-row>

        </div>
        <el-row v-if="parentInfo.student_list" class="row-section">
          <h3>{{ $t('common.children_information') }}</h3>
        </el-row>
        <el-row style="padding: 20px">
          <table v-if="parentInfo.student_list" class="bus-list">
            <tr>
              <th>#</th>
              <th>{{ $t('common.full_name') }}</th>
              <th>{{$t('nameField.grade')}}</th>
              <th>{{ $t('common.class') }}</th>
              <th>{{ $t('common.bus_stop') }}</th>
              <th>{{$t('add_parent.isNotNeedPickedUp')}}</th>
              <th>{{ $t('common.active') }}</th>
              <th></th>
            </tr>
            <template v-for="(children, index) in parentInfo.student_list">
              <tr  :key="children.id" class="item-parent">
                <td>{{ index +1 }}</td>
                <td>{{ children.fullname }}</td>
                <td>{{children.grade ? children.grade.name : ''}}</td>
                <td>{{ children.class_info ? children.class_info.name : '' }}</td>
                <td>{{ children.place_info ? children.place_info.name : '' }}</td>
                <td>
                  <i v-if="children.is_not_need_picked_up" class="el-icon-check font-weight-bold text-primary"></i>
                </td>
                <td>{{ children.is_active ? $t('common.yes') : $t('common.no') }}</td>
                <td>
                  <b-button v-if="children.is_active" variant="primary" @click="onSendEmailToParent(children.id)">{{ $t('sendEmailStudent') }}</b-button>
                </td>
              </tr>
              <tr class="item-agent" :key="children.id + 'row2'" v-if="children.is_approve && children.authorized_person_list && children.authorized_person_list.length > 0">
                <td colspan="7">
                  <el-row >
                    <h6 style="margin-bottom: 0; margin-top: 10px;color: #ffac41">{{ $t('common.agent_information') }}</h6>
                  </el-row>
                  <el-row style="padding: 10px 20px 20px">
                    <table v-if="children.authorized_person_list" class="bus-list agent-list">
                      <tr>
                        <th>#</th>
                        <th>{{ $t('common.full_name') }}</th>
                        <th>{{ $t('common.phone') }}</th>
                      </tr>
                      <tr v-for="(agent, k) in children.authorized_person_list" :key="agent.id">
                        <td>{{ k + 1 }}</td>
                        <td>{{ agent.name }}</td>
                        <td>{{ agent.phone }}</td>
                      </tr>
                    </table>
                  </el-row>
                </td>
              </tr>
            </template>

          </table>
        </el-row>

      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailParent",
    components: {
      PageTitle
    },
    data: function () {
      let referer = this.$route.query.referer

      return {
        title: 'common.parent_information',
        referer,
        backLink: referer === 'student' ? `/student?action=back` : `/parent?action=back`
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        parent_id: this.$route.query.pid
      }
      this.$store.dispatch('parent/getParentInfo', payload)
    },
    computed: {
      ...mapState('parent', ['parentInfo']),
    },
    methods: {

      getImageByType(url){
        let fileType = this.get_url_extension(url)
        let fileImage = ['jpg', 'jpeg', 'png', 'tiff', 'raw', 'svg', 'bmp', 'heic']
        if(fileImage.includes(fileType)){
          return url
        }else{
          return `https://via.placeholder.com/300x200?text=.${fileType}`
        }
      },
      get_url_extension( url ) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
      },
      onShowPreviewPDF(url){
        window.open(url, '_blank')
      },
      onSendEmailToParent(id){
        let successCallback = (response) =>{
          if(response.status === 200){
            this.$store.commit('openNotification', {
              type: 'success',
              message: this.$t('parent_list.send_mail_success')
            })
          }
        }
        let errorCallback = () => {}
        let payload = {
          successCallback,
          errorCallback,
          idStudent: id
        }
        this.$store.dispatch('parent/sendEmailInfoStudent', payload)
      },
      goToEdit: function () {
        let query = {
          pid: this.$route.query.pid
        }

        if (this.referer) {
          query.referer = this.referer
        }

        this.$router.push({path: '/parent/edit', query});
      }
    }
  }
</script>

<style lang="scss">

  .info-span {
    font-size: 20px;
    float: left;
    line-height: 40px;
    &__file{
      border-radius: 8px;
      max-width: 300px;
      height: 200px;
      width: 100%;
      border: 3px solid #dbdbdb;
    }
  }
  .item-parent{
    background: #efefef;
    &:hover + tr{
      background: rgba(239, 239, 239, 0.48);
    }
  }
  .item-agent{
    &:hover{
      background: rgba(239, 239, 239, 0.48);
    }
  }
  .agent-list{
    th{
      background: #efefef;
      color: #777;
      height: 30px;
    }
    td{
      background: #fff;
    }
  }
</style>
